export { createPetiteVueDynamicRenderer } from './petiteVue';
